export const AM_PM = ['am', 'pm']; 